import { Card } from "ui/components/card";
import { cn } from "ui/lib/utils";

export default function RatingScale({
  value,
  onChange,
  error,
  question,
  minLabel = "Needs Improvement",
  maxLabel = "Excellent",
  className,
  disabled,
}) {
  return (
    <Card className={cn("flex flex-col p-6 gap-3 shadow-none", className)}>
      {question && (
        <h3 className="text-base font-semibold text-zinc-950  leading-snug">
          {question}
        </h3>
      )}
      <div className="flex gap-2 justify-between items-center w-full">
        {Array.from({ length: 10 }, (_, i) => i + 1).map((val) => {
          const isSelected = String(value) === String(val);
          let btnClass = "";

          if (val <= 6) {
            btnClass = isSelected
              ? "bg-red-400 text-white  shadow-sm"
              : `bg-red-100 text-red-600 ${disabled ? "" : "hover:bg-red-200"}`;
          } else if (val <= 8) {
            btnClass = isSelected
              ? "bg-amber-400 text-white  shadow-sm"
              : `bg-amber-100 text-amber-700 ${disabled ? "" : "hover:bg-amber-200"}`;
          } else {
            btnClass = isSelected
              ? "bg-green-400 text-white  shadow-sm"
              : `bg-green-100 text-green-700 ${disabled ? "" : "hover:bg-green-200"}`;
          }

          return (
            <button
              key={val}
              type="button"
              onClick={() => !disabled && onChange?.(val)}
              className={cn(
                "w-10 h-10 md:w-13 md:h-13 text-xs md:text-sm rounded-full flex items-center justify-center  cursor-pointer transition-all duration-150 ",
                btnClass,
                disabled && "cursor-not-allowed ",
              )}
            >
              {val}
            </button>
          );
        })}
      </div>

      <div className="flex justify-between w-full px-1 text-xs   select-none">
        <span>{minLabel}</span>
        <span>{maxLabel}</span>
      </div>

      {error && (
        <span className="text-red-500 text-xs mt-2 font-medium">{error}</span>
      )}
    </Card>
  );
}
